import { Button, Card, Space } from 'antd';
import { FC } from 'react';
import { CloudArrowUp, FileEarmarkZip, Gear, Journals } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { AppRoutes, BaseQueryParams } from '@/common/interfaces';
import { CommonContainerTitle } from '@/common/layouts';

import { useGetContentByIdSitesQuery } from '@/modules/Sites';

import { SitesOverviewCardsView } from './SitesOverviewCardsView';

interface Props {
  site: BaseQueryParams<typeof useGetContentByIdSitesQuery>['data'];
  disableButtons: boolean;
  sitesUploadArchivesModalOpen: () => void;
  sitesUploadArchiveModalOpen: () => void;
}

export const SitesOverviewView: FC<Props> = ({
  site,
  disableButtons,
  sitesUploadArchivesModalOpen,
  sitesUploadArchiveModalOpen,
}) => {
  return (
    <>
      <CommonContainerTitle
        onlyExtra
        extra={
          <Space>
            <Link to={AppRoutes.SitesFSManager.replace(':siteId', site.id)}>
              <Button type="default" disabled={disableButtons} icon={<Journals />}>
                Файловий менеджер
              </Button>
            </Link>

            <Space.Compact>
              <Button type="default" disabled={disableButtons} onClick={sitesUploadArchiveModalOpen} icon={<CloudArrowUp />}>
                Імпорт сайту з архіву
              </Button>

              <Button type="default" disabled={disableButtons} onClick={sitesUploadArchivesModalOpen} icon={<FileEarmarkZip />} />
            </Space.Compact>

            <Link to={AppRoutes.SitesDossier.replace(':siteId', site.id)}>
              <Button type="default" icon={<Gear />} />
            </Link>
          </Space>
        }
      />

      <SitesOverviewCardsView siteId={site.id} />
    </>
  );
};
